export {
    Type,
    fromJSON,
    instanceOf,
    fromHexString,
    fromBuffer,
    toHexString,
    equals,
    Serializable,
    JSON_DISCRIMINATOR,
    fromTypedJSON,
    toUnwrappedJSON,
    toTypedJSON,
} from '../../types/ModuleReference.js';
